﻿window.cObjetContactEmailMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "contact email"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau contact email"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            if (typeof objet.data.nom_usuel != 'undefined' && objet.data.nom_usuel != null && objet.data.nom_usuel.length > 0) {
                txt = objet.data.nom_usuel
            } else if (typeof objet.data.adresse_email != 'undefined' && objet.data.adresse_email != null && objet.data.adresse_email.length > 0) {
                txt = objet.data.adresse_email
            }
        } else {
            txt = "contact email"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data == 'undefined') {
        } else {
            if (typeof objet.data.nom_usuel != 'undefined' && objet.data.nom_usuel != null && objet.data.nom_usuel.length > 0) {
                txt += objet.data.nom_usuel[0].toUpperCase() + ((objet.data.nom_usuel.length > 1) ? objet.data.nom_usuel[1].toUpperCase() : "")
            } else if (typeof objet.data.adresse_email != 'undefined' && objet.data.adresse_email != null && objet.data.adresse_email.length > 0) {
                txt += objet.data.adresse_email[0].toUpperCase() + ((objet.data.adresse_email.length > 1) ? objet.data.adresse_email[1].toUpperCase() : "")
            }
        }
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-at' style='position:relative'><i class='fas fa-face-smile' style='position:absolute;bottom:0;right:0;font-size:50%;color:" + theme.backgroundcolorAccent + ";'></i></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged
        })
    }

    this.mGetContentDisplay = function (contentElement, option) {
        contentElement.css("padding", "20px 20px 20px 20px")
        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text'>Nom usuel</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.nom_usuel) ? objet.data.nom_usuel : "(aucun)") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text'>Adresse email</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.adresse_email + "</td>").appendTo($Tr)
    }

    this.hasScrollPopup = function () { return false }
    //this.mShowPopup = function (optionPopup) {
    //}

    this.mGetAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }

    this.mCreateFromEmail = function (email, funcOk) {
        //on vérifie d'abord si on a pas dans la base un élément qui dispose du mail
        Me.objet.bddRef.mAjaxCall({
            command: "getlstcontactfromemail",
            adresse_email: email
        }, function (data) {
            if (typeof data.lstcontact != 'undefined' && data.lstcontact.length > 0) {
                //on a trouvé un élément
                var nomTable = Me.objet.bddRef.table.mGetItem(data.lstcontact[0].id_table).nom
                var obj = Me.objet.bddRef.getObjet(nomTable, data.lstcontact[0].id)
                funcOk(data.lstcontact[0].id_table, obj.data)
            } else {
                //on a pas trouvé d'élément qui dispose du mail
                var dataContact = Me.objet.bddRef.getObjet("contact_email").mGetNewData()
                dataContact.adresse_email = email
                dataContact.nom_usuel = ""
                dataContact.visible = "1"
                var obj = Me.objet.bddRef.getObjet(dataContact)
                obj.mSave(function (data) {
                    funcOk(obj.mGetTable().id_table, obj.data)
                })
            }
        })
    }

}